import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Dashboard } from "./pages/Dashboard";
import { DocumentGenerator } from "./pages/DocumentGenerator";
import { MyDocuments } from "./pages/MyDocuments";
import { DocumentDetail } from "./pages/DocumentDetail";
import { Settings } from "./pages/Settings";
import { AdminUsers } from "./pages/AdminUsers";
import { AdminSubjects } from "./pages/AdminSubjects";
import { AdminPackages } from "./pages/AdminPackages";
import { Topup } from "./pages/Topup";
import { VerifyEmailPending } from "./pages/VerifyEmailPending";
import { VerifyEmailConfirm } from "./pages/VerifyEmailConfirm";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfService } from "./pages/TermsOfService";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmailPending />} />
              <Route path="/verify-email/confirm" element={<VerifyEmailConfirm />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/documents/generate"
                element={
                  <ProtectedRoute allowedRoles={["guru"]}>
                    <DocumentGenerator />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/documents"
                element={
                  <ProtectedRoute allowedRoles={["guru"]}>
                    <MyDocuments />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <ProtectedRoute allowedRoles={["super_admin"]}>
                    <Settings />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/documents/:id"
                element={
                  <ProtectedRoute allowedRoles={["guru"]}>
                    <DocumentDetail />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/topup"
                element={
                  <ProtectedRoute allowedRoles={["guru"]}>
                    <Topup />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/users"
                element={
                  <ProtectedRoute allowedRoles={["super_admin"]}>
                    <AdminUsers />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/subjects"
                element={
                  <ProtectedRoute allowedRoles={["super_admin"]}>
                    <AdminSubjects />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/packages"
                element={
                  <ProtectedRoute allowedRoles={["super_admin"]}>
                    <AdminPackages />
                  </ProtectedRoute>
                }
              />

              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
